import React from 'react';
import { Copy, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { patternLocation } from '@/lib/patternLocation';

export function PatternLocationActions({ value }) {
  const location = patternLocation(value);
  const [message, setMessage] = React.useState('');
  React.useEffect(() => setMessage(''), [value]);
  if (!location.raw) return null;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(location.raw);
      setMessage('Ruta copiada. Pégala en el Explorador de archivos o en Finder → Ir a la carpeta.');
    } catch {
      setMessage('No se pudo copiar. Selecciona y copia la ubicación del campo manualmente.');
    }
  };
  return <div className="space-y-1 text-xs">
    <div className="flex flex-wrap gap-2">
      {location.href && <Button asChild variant="outline" size="sm">
        <a href={location.href} target="_blank" rel="noopener noreferrer"><ExternalLink className="mr-2 h-4 w-4" />Abrir ubicación</a>
      </Button>}
      <Button type="button" variant="outline" size="sm" onClick={copy}><Copy className="mr-2 h-4 w-4" />Copiar ruta</Button>
    </div>
    {location.local && <p className="text-gray-500">Las rutas locales requieren acceso desde este equipo. Si el navegador bloquea la apertura, copia la ruta y ábrela desde el Explorador de archivos o Finder.</p>}
    {!location.href && <p className="text-gray-500">Para abrirla, indica una URL http(s), file:// o una ruta absoluta local o de red.</p>}
    {message && <p role="status">{message}</p>}
  </div>;
}
